import axiosInstance from "./axiosInstance";

const httpServices = {
  async get(endpoint, options = {}) {
    const { skip = false } = options;
    let loading = false;
    let error = null;

    if (skip) {
      return { response: null, loading, error };
    }

    loading = true;
    try {
      const response = await axiosInstance.get(endpoint);
      loading = false;
      return { response, loading, error };
    } catch (err) {
      loading = false;
      error = err;
      return { response: null, loading, error };
    }
  },

  async post(endpoint, data, options = {}, progress) {
    const { skip = false } = options;
    let loading = false;
    let error = null;

    if (skip) {
      return { response: null, loading, error };
    }

    loading = true;
    try {
      const response = await axiosInstance.post(endpoint, data, progress);
      loading = false;
      return { response, loading, error };
    } catch (err) {
      loading = false;
      error = err;
      return { response: null, loading, error };
    }
  },

  async put(endpoint, data, options = {}) {
    const { skip = false } = options;
    let loading = false;
    let error = null;

    if (skip) {
      return { response: null, loading, error };
    }

    loading = true;
    try {
      const response = await axiosInstance.put(endpoint, data);
      loading = false;
      return { response, loading, error };
    } catch (err) {
      loading = false;
      error = err;
      return { response: null, loading, error };
    }
  },

  async patch(endpoint, data, options = {}) {
    const { skip = false } = options;
    let loading = false;
    let error = null;

    if (skip) {
      return { response: null, loading, error };
    }

    loading = true;
    try {
      const response = await axiosInstance.patch(endpoint, data);
      loading = false;
      return { response, loading, error };
    } catch (err) {
      loading = false;
      error = err;
      return { response: null, loading, error };
    }
  },

  async delete(endpoint, options = {}) {
    const { skip = false } = options;
    let loading = false;
    let error = null;

    if (skip) {
      return { response: null, loading, error };
    }

    loading = true;
    try {
      const response = await axiosInstance.delete(endpoint);
      loading = false;
      return { response, loading, error };
    } catch (err) {
      loading = false;
      error = err;
      return { response: null, loading, error };
    }
  },
};

export default httpServices;
